<template>
  <div class="col-md-12">
    <div class="card card-container">
      <h4><font-awesome-icon icon="plus-square" /> Add Country</h4>
      <form name="form" @submit.prevent="saveCountry">
        <div v-if="!successful">
          <div class="form-group">
            <label for="code">Code:</label>
            <input v-model="country.code" v-validate="'required|min:2|max:6'" type="text" class="form-control" id="code" name="code"/>
            <div v-if="submitted && errors.has('code')" class="alert-danger">{{errors.first('code')}}</div>
          </div>
          <div class="form-group">
            <label for="name">Name:</label>
            <input v-model="country.name" v-validate="'required|min:3|max:75'" type="text" class="form-control" id="name" name="name"/>
            <div v-if="submitted && errors.has('name')" class="alert-danger" >{{errors.first('name')}}</div>
          </div>
          <div class="form-group">
            <button type="submit" class="m-3 btn btn-sm btn-success"><font-awesome-icon icon="save" /> Save</button>
            <button class="m-3 btn btn-sm btn-primary" @click="countriesList"><font-awesome-icon icon="arrow-alt-circle-left" /> Back</button>
          </div>
        </div>
      </form>

      <div v-if="message" class="alert" :class="successful ? 'alert-success' : 'alert-danger'">
        {{message}}
      </div>
      <div v-if="message && successful">
        <button class="btn btn-primary" @click="newCountry"><font-awesome-icon icon="plus" /> Add Country</button>
      </div>
    </div>
  </div>
</template>

<script>
import CountryService from "../services/country.service";
//import Country from '../models/country';

export default {
  name: 'add-country',
  data() {
    return {
      country: {
        id: null,
        code: '',
        name: ''
      },
      /*country: new Country('', ''),*/
      submitted: false,
      successful: false,
      message: '',
    };
  },
  computed: {
    loggedIn() {
      return this.$store.state.auth.status.loggedIn;
    }
  },
  methods: {
    saveCountry() {
      var countryData = {
        code: this.country.code,
        name: this.country.name
      };
      this.message = '';
      this.submitted = true;
      this.$validator.validate().then(isValid => {
        if (isValid) {
          CountryService.create(countryData).then(
            response => {
              this.message = 'The country was created successfully!';
              this.country.id = response.data.id;
              //console.log('data: '+response.data);
              this.submitted = true;
              this.successful = true;
            },
            error => {
              this.message = (error.response && error.response.data) || error.message || error.toString();
              this.successful = false;
            })
            .catch(e => {
              console.log('e: '+e);
              this.message = e.message;
              console.log('e message: '+e.message);
            });
        }
      });
    },

    newCountry() {
      this.submitted = false;
      this.successful = false;
      this.message = '';
      this.country = {};
    },
    
    countriesList() {
      this.$router.push('/countries');
    }
  }
};
</script>

<style scoped>
label {
  display: block;
  margin-top: 10px;
  font-size: 1.2em;
  text-align: left;
}

.card-container.card {
  max-width: 750px !important;
  padding: 40px 40px;
}

.card {
  background-color: #f7f7f7;
  padding: 20px 25px 30px;
  margin: 0 auto 25px;
  margin-top: 50px;
  -moz-border-radius: 2px;
  -webkit-border-radius: 2px;
  border-radius: 2px;
  -moz-box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.3);
  -webkit-box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.3);
  box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.3);
}

.profile-img-card {
  width: 96px;
  height: 96px;
  margin: 0 auto 10px;
  display: block;
  -moz-border-radius: 50%;
  -webkit-border-radius: 50%;
  border-radius: 50%;
}
</style>